export enum EServicesErrorCode {
  /** User logged in without permissions 👉 redirect to autoprospect success page */
  LOGGED_IN_NO_PERMISSIONS = 'SFE0326',
  /** Maintenance mode 👉 redirect to maintenance page */
  REDIRECT_TO_MAINTENANCE = 'SFE0309',

  /** User disabled 👉 redirect to logout */
  UNAVAILABLE_USER = 'SFE0301',

  /** User does not exist 👉 redirect to logout  */
  USER_NO_EXIST = 'SFE0300',

  CART_STOCK_EXCEED = 'SFE1505',
  /** Minimum sale amount not reached 👉 redirect to homepage and show snackbar */
  CHECKOUT_MINIMUM_SALE_AMOUNT_NOT_REACHED = 'SFE1601',
  /** There are no products in checkout 👉 disable continue button in checkout */
  CHECKOUT_THERE_ARE_NO_PRODUCTS = 'SFE1600',
  /** Minimum sale amount not set 👉 disable continue button in checkout */
  CHECKOUT_BAD_USER_CONFIGURATION = 'SFE1516',
  /** Distributor schedules not set 👉 disable continue button in checkout */
  CHECKOUT_SCHEDULES_NOT_SET = 'SFE0311',
  /** Delivery dates with error 👉 disable continue button in checkout */
  CHECKOUT_DELIVERY_DATES_ERROR = 'SFE1520',
  /** User Codimod not set 👉 disable continue button in checkout */
  CHECKOUT_NO_CODIMOD_SET = 'SFE1519',
  /** Minimum sale amount not reached  in shopping cart 👉 disable continue button in shopping cart */
  CART_MINIMUM_SALE_AMOUNT_NOT_REACHED = 'MinimumSaleAmountNotReached',
  /** Minimum sale amount or distributor schedules not set  👉 disable continue button in shopping cart */
  CART_BAD_USER_CONFIGURATION = 'IncorrectUserConfiguration',
}
